import RetryPaymentOverlays from '../RetryPaymentOverlays/RetryPaymentOverlays';
import RetryPaymentSwitch from '../RetryPaymentSwitch/RetryPaymentSwitch';

import SentryErrorBoundary from '@components/SentryErrorBoundary/SentryErrorBoundary';
import ConfigProvider from '@providers/ConfigProvider';
import I18nProvider from '@providers/I18nProvider';
import KeycloakTokenProvider from '@providers/KeycloakTokenProvider';
import OverlaysProvider from '@providers/OverlaysProvider';
import Providers from '@providers/Providers';
import RetryDataProvider from '@providers/RetryDataProvider';
import ThunkDispatchProvider from '@providers/ThunkDispatchProvider';
import { Environment, Locale, ShopBundle } from '@types-internal';

export type RetryPaymentProps = {
  shopBundle: ShopBundle;
  domain: string;
  locale: Locale;
  orderId: string;
  customerId: string;
  env: Environment;
};

const RetryPayment: React.FC<RetryPaymentProps> = ({
  shopBundle,
  domain,
  locale,
  orderId,
  customerId,
  env,
}) => {
  return (
    <ConfigProvider env={env} shopBundle={shopBundle}>
      <I18nProvider env={env} shopBundle={shopBundle} locale={locale}>
        <SentryErrorBoundary featureName="retry-payment">
          <Providers shopBundle={shopBundle} domain={domain} locale={locale}>
            <KeycloakTokenProvider>
              <RetryDataProvider customerId={customerId}>
                <ThunkDispatchProvider>
                  <OverlaysProvider>
                    <RetryPaymentSwitch orderId={orderId} customerId={customerId} />
                    <RetryPaymentOverlays />
                  </OverlaysProvider>
                </ThunkDispatchProvider>
              </RetryDataProvider>
            </KeycloakTokenProvider>
          </Providers>
        </SentryErrorBoundary>
      </I18nProvider>
    </ConfigProvider>
  );
};

export default RetryPayment;
